import { MARGIN, PIE_CHART_DIMENSIONS } from '@DashboardV2/common/utils';
import { Box, Stack, styled, Typography } from '@mui/material';

const BG_COLOR = '#D9D9D9';
const CIRCLE_SIZE = 64;

const EmptyPieWrapper = styled(Box)({
  width: PIE_CHART_DIMENSIONS + 2 * MARGIN,
  overflow: 'hidden',
  alignSelf: 'center',
});

const Circle = styled(Box)(() => ({
  width: PIE_CHART_DIMENSIONS,
  height: PIE_CHART_DIMENSIONS,
  borderRadius: '50%',
  backgroundColor: BG_COLOR,
  display: 'flex',
  alignSelf: 'center',
  marginRight: MARGIN,
  marginLeft: MARGIN,
}));

const SmallCircle = styled(Circle)(() => ({
  width: CIRCLE_SIZE,
  height: CIRCLE_SIZE,
  backgroundColor: BG_COLOR,
}));

interface PieChartEmptyStateProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  variant?: 'default' | 'small';
}

export function PieChartEmptyState({ title, subtitle, action, variant }: PieChartEmptyStateProps) {
  return (
    <Stack direction="column" spacing={3} justifyContent="center" alignItems="center">
      {variant === 'small' ? (
        <SmallCircle />
      ) : (
        <EmptyPieWrapper>
          <Circle />
        </EmptyPieWrapper>
      )}
      <Stack direction="column" spacing={0.5} justifyContent="center" alignItems="center">
        <Typography variant="body2">{title}</Typography>
        {subtitle && (
          <Typography variant="helperText" color="text.muted">
            {subtitle}
          </Typography>
        )}
      </Stack>
      {action}
    </Stack>
  );
}
